import { render } from "./PlsMaterialPreparation.vue?vue&type=template&id=eb87bc04&scoped=true"
import script from "./PlsMaterialPreparation.vue?vue&type=script&lang=js"
export * from "./PlsMaterialPreparation.vue?vue&type=script&lang=js"

import "./PlsMaterialPreparation.vue?vue&type=style&index=0&id=eb87bc04&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb87bc04"]])

export default __exports__